import { Device, from, until } from '@helpers/media';
import SimpleTrackStyles from '@stories/Components/Misc/Carousel/SimpleTrack/SimpleTrack.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const CarouselSpacing = 12;
const Container = styled(SectionWrapper) `
  margin: var(--sectionSpacing) 0;
  overflow: hidden;
`;
const CarouselWrapper = styled.div `
  /* Adjust the left/right margin of the carousel wrapper by the amount of padding 
  added to cards and track wrapper to ensure that the width is correct */
  margin-left: -${CarouselSpacing / 2}px;
  margin-right: -${CarouselSpacing / 2}px;

  @media ${from(Device.TabletSmall)} {
    margin-left: 0;
    margin-right: 0;

    ${SimpleTrackStyles.Track} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 32px 30px;
    }
  }

  @media ${from(Device.Desktop)} {
    ${SimpleTrackStyles.Track} {
      gap: 45px 40px;

      [data-column-count='3'] & {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
`;
const Item = styled.li `
  flex: 0 0 100%;

  /* Ensure spacing between cards */
  padding: 0 ${CarouselSpacing / 2}px;

  /* Required to ensure that item stays visible while carousel animates */
  transition: visibility 0.5s ease;
  @media ${until(Device.MobileLarge)} {
    &[data-active-item='false'] {
      visibility: hidden;
    }
  }

  @media ${from(Device.TabletSmall)} {
    padding: 0;
  }
`;
const ControlsWrapper = styled.div `
  @media ${from(Device.TabletSmall)} {
    display: none;
  }
`;
const SignpostCardsSectionStyles = {
    Container,
    CarouselWrapper,
    Item,
    ControlsWrapper,
};
export default SignpostCardsSectionStyles;
